module.exports = __webpack_public_path__ + "img/parker-main-hero.fe4cde51.webp";